export const SET_CARD = 'SET_CARD'
export const SWITCH_CARD = 'SWITCH_CARD'
export const REMOVE_CARD = 'REMOVE_CARD'
export const CHANGE_CARDS = 'CHANGE_CARDS'
export const SET_RESOURCE = 'SET_RESOURCE'
export const REMOVE_RESOURCE = 'REMOVE_RESOURCE'
export const SET_PROJECT = 'SET_PROJECT'
export const REMOVE_PROJECT = 'REMOVE_PROJECT'
export const PICK_PROJECT = 'PICK_PROJECT'
export const MOVE_CARD = 'MOVE_CARD'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js